const isMobileDevice = () =>
  /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

export function isMobileOtpAutoFillDevice() {
  return isMobileDevice();
}
